/**
 * Asterove 品牌字标：紫色花瓣加琥珀花心，取自官网仓库 Asterove 的 src/BrandMark.jsx。
 *
 * 背景：创始人 2026-11-03 指定 Logo 与字体直接用 Asterove 官网的，不另做。
 * 设计意图：和官网同一套 SVG 几何（16 片花瓣、花心、种子点），颜色写成 CSS 变量，
 *   控制台与管理后台在同一处引用，后续换品牌色只改 brand.css。
 * 关键约束：Asterove Sans 只有 Regular 字重，字标不要加粗（font-synthesis 已关）；
 *   动画 30 秒一圈，prefers-reduced-motion 下停止。
 */
export function BrandMark({ size = 27, animated = true }: { size?: number; animated?: boolean }) {
  return (
    <svg className={`aster-mark${animated ? ' is-animated' : ''}`} width={size} height={size} viewBox="0 0 36 36" aria-hidden="true">
      <g className="aster-petals">
        {Array.from({ length: 16 }, (_, i) => (
          <ellipse className="aster-petal" key={i} cx="18" cy="7.8" rx="2.25" ry="6.4" transform={`rotate(${i * 22.5} 18 18)`} />
        ))}
      </g>
      <circle className="aster-halo" cx="18" cy="18" r="6.2" />
      <circle className="aster-core" cx="18" cy="18" r="4.1" />
      <circle className="aster-seed" cx="16.5" cy="16.6" r="0.65" />
      <circle className="aster-seed" cx="19.5" cy="17.2" r="0.55" />
      <circle className="aster-seed" cx="17.8" cy="19.5" r="0.6" />
      <circle className="aster-seed" cx="20.1" cy="20" r="0.45" />
    </svg>
  )
}
